"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var AgentFlag;
(function (AgentFlag) {
  AgentFlag["REI_LOGO_ACT"] = "REI_LOGO_ACT";
  AgentFlag["REI_LOGO_NSW"] = "REI_LOGO_NSW";
})(AgentFlag || (AgentFlag = {}));
var _default = exports.default = AgentFlag;